<h1 class="page-title">Login</h1>

<div class="container-fluid text-center mb-5">
  <div class="text-center" *ngIf="isLoading">
    <app-loading-spinner></app-loading-spinner>
  </div>
  <div id="form-box" class="container">
    <form [formGroup]="loginForm" *ngIf="!isLoading">
      <div class="form-group">
        <input type="email" class="form-control" formControlName="email" placeholder="Email">
      </div>
      <div class="form-group my-3">
        <input type="password" class="form-control" formControlName="password" placeholder="Password">
      </div>
      <div class="mt-3 alert alert-danger" *ngIf="errorMessage">{{errorMessage}}</div>
      <div class="mt-3 alert alert-success" *ngIf="message">{{message}}</div>
      <button class="btn btn-primary" (click)="onLogin()">Submit</button>
    </form>
  </div>
</div>
